import { ReactNode, useState } from "react";
import {
  Pressable,
  StyleProp,
  StyleSheet,
  View,
  ViewStyle,
} from "react-native";

export function CentralInteractiveSurface({
  accessibilityHint,
  accessibilityLabel,
  children,
  contentStyle,
  focusedStyle,
  footer,
  footerStyle,
  onPress,
  pressedStyle,
  style,
  testID,
}: {
  accessibilityHint?: string;
  accessibilityLabel: string;
  children: ReactNode;
  contentStyle?: StyleProp<ViewStyle>;
  focusedStyle?: StyleProp<ViewStyle>;
  footer?: ReactNode;
  footerStyle?: StyleProp<ViewStyle>;
  onPress: () => void;
  pressedStyle?: StyleProp<ViewStyle>;
  style?: StyleProp<ViewStyle>;
  testID?: string;
}) {
  const [focused, setFocused] = useState(false);
  const [pressed, setPressed] = useState(false);

  return (
    <View
      style={[
        styles.surface,
        style,
        focused ? focusedStyle : null,
        pressed ? pressedStyle : null,
      ]}
    >
      <Pressable
        accessibilityHint={accessibilityHint}
        accessibilityLabel={accessibilityLabel}
        accessibilityRole="button"
        onBlur={() => setFocused(false)}
        onFocus={() => setFocused(true)}
        onPress={onPress}
        onPressIn={() => setPressed(true)}
        onPressOut={() => setPressed(false)}
        style={styles.primaryAction}
        testID={testID}
      />
      <View pointerEvents="none" style={[styles.content, contentStyle]}>
        {children}
      </View>
      {footer ? (
        <View pointerEvents="box-none" style={[styles.footer, footerStyle]}>
          {footer}
        </View>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  content: { position: "relative", zIndex: 1 },
  footer: { position: "relative", zIndex: 2 },
  // StyleSheet.absoluteFillObject was removed from the RN 0.85 types.
  primaryAction: { position: "absolute", left: 0, right: 0, top: 0, bottom: 0 },
  surface: { position: "relative" },
});
